import { useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";
import { Button, Container, Image } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useParams } from "react-router-dom";

import BgWaveTop from "images/bg/bckg-branded-top.svg";
import { useTutoringResetMutation } from "api/generated";
import { processApiError } from "utils/processApiError";

const TutoringEvaluation = () => {
  const { t } = useTranslation("tutoring");
  const { tutoringId, subjectSlug } = useParams();

  if (!subjectSlug) return null;

  const [resetTutoring, { error: apiError }] = useTutoringResetMutation();

  useEffect(() => {
    if (apiError === undefined) return;

    processApiError(apiError);
  }, [apiError]);

  const reset = () => {
    if (!tutoringId) return;

    resetTutoring({ tutoringId })
      .then(() => {
        window.location.reload();
      })
      .catch(() => {});
  };

  return (
    <main className={"fullpage bg-cyan-200"}>
      <BgWaveTop className={"wave__top"} />

      <Container className="container-mw-sm fullpage__content">
        <div className="page">
          <div className="page__content my-auto ms-sm-0 flex-grow-0">
            <div className="d-flex flex-row pb-20px">
              <Image src={"/images/topic-evaluation.svg"} />

              <h1 className="h2 my-20px">{t("evaluation.title")}</h1>
            </div>
            <p>
              <Trans i18nKey="evaluation.description" ns="tutoring" components={{ br: <br /> }} />
            </p>
          </div>
        </div>
      </Container>

      <div className="fullpage__footer bg-cyan-200 pt-2">
        <Container className="container-mw-sm">
          <LinkContainer to={`/doucovani/${subjectSlug}`} className="mb-12px">
            <Button className={"w-100 btn-azure"}>{t("close", { ns: "common" })}</Button>
          </LinkContainer>

          <Button className={"w-100 btn-transparent btn-narrow"} onClick={reset}>
            <Trans i18nKey="evaluation.reset" ns="tutoring" components={{ br: <br /> }} />
          </Button>
        </Container>
      </div>
    </main>
  );
};

export default TutoringEvaluation;
